import dayjs from 'dayjs'

import { DATE_FORMAT } from '@/Ship/Configs/DateFormat'

import { MINUTE, HOUR, DAY } from '../Helpers/time'

/**
 * Formats a timestamp relative to now (user presence).
 * "Щойно" / "5 хв тому" / "2 год тому" / "Вчора" / "дд.мм.рррр"
 */
export function formatRelativeTime(timestamp: number): string {
  const now = Date.now()
  const diff = now - timestamp

  if (diff < MINUTE) return 'Щойно'
  if (diff < HOUR) return `${Math.floor(diff / MINUTE)} хв тому`
  if (diff < 2 * HOUR) return '1 год тому'
  if (diff < DAY) return `${Math.floor(diff / HOUR)} год тому`

  const todayStart = new Date(now)
  todayStart.setHours(0, 0, 0, 0)
  const yesterdayStart = new Date(todayStart.getTime() - DAY)

  if (timestamp >= yesterdayStart.getTime() && timestamp < todayStart.getTime()) return 'Вчора'

  return dayjs(timestamp).format(DATE_FORMAT)
}

/**
 * Час останнього повідомлення в списку чатів: «14:05» сьогодні, «Вчора»,
 * «28.09» цього року, «28.09.2025» — давніше.
 *
 * Абсолютний, а не «5 хв тому»: список не перемальовується за таймером, і
 * відносний час застигав — «Щойно» могло висіти годину.
 */
export function formatListTime(timestamp: number): string {
  const date = dayjs(timestamp)
  const today = dayjs().startOf('day')

  if (!date.isBefore(today)) return date.format('HH:mm')
  if (!date.isBefore(today.subtract(1, 'day'))) return 'Вчора'

  return date.format(date.year() === today.year() ? 'DD.MM' : DATE_FORMAT)
}

/**
 * Formats a timestamp for message bubble. "HH:MM"
 */
export function formatMessageTime(timestamp: number): string {
  const date = new Date(timestamp)
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${hours}:${minutes}`
}

/**
 * Статус співрозмовника: «щойно в мережі», «востаннє в мережі 5 хв тому».
 *
 * Без «був(ла)»: дужки в слові читаються як недороблений шаблон, а рід із
 * профілю не відомий — формулювання обходиться без нього.
 */
export function formatLastSeen(timestamp: number): string {
  const relative = formatRelativeTime(timestamp)
  if (relative === 'Щойно') return 'щойно в мережі'
  return `востаннє в мережі ${relative.toLowerCase()}`
}
